import "./Storefront.scss"
import React, { Component } from "react"
import { observer } from "mobx-react"
import { storefrontStore } from "../stores"
import StorefrontPreview from "./StorefrontPreview"
import {
  AppHeader,
  AppPanel,
  Button,
  TextInput,
  TextArea,
  ImageUploader,
} from "../lib"

class Storefront extends Component {
  componentWillMount() {
    storefrontStore.reset()
  }

  handleSubmit = e => {
    e.preventDefault()
    storefrontStore.save()
  }

  render() {
    return (
      <div>
        <AppHeader>
          <h1>Customize your store</h1>
        </AppHeader>
        <AppPanel>
          <div className="Storefront">
            <form className="Storefront_form" onSubmit={this.handleSubmit}>
              <label>
                <h5>Store Name</h5>
                <TextInput
                  placeholder="Enter your store name..."
                  value={storefrontStore.name}
                  onChange={storefrontStore.changeName}
                />
              </label>
              <label>
                <h5>Store Description</h5>
                <TextArea
                  placeholder="Enter a description for your store..."
                  value={storefrontStore.description}
                  rows={3}
                  onChange={storefrontStore.changeDescription}
                />
              </label>
              <label>
                <h5>Preview Message</h5>
                <TextArea
                  placeholder="Enter a message for your store preview..."
                  value={storefrontStore.previewMessage}
                  rows={3}
                  onChange={storefrontStore.changePreviewMessage}
                />
                <p style={{ fontSize: 12, color: "#888" }}>
                  The preview message displays to first-time visitors after a
                  short delay. Leave blank to hide the preview.
                </p>
              </label>
              <label>
                <h5>Store Logo</h5>
                <div style={{ width: 150 }}>
                  <ImageUploader
                    value={storefrontStore.logo}
                    onChange={storefrontStore.changeLogo}
                  />
                </div>
              </label>
              <Button
                type="submit"
                styleName="submit"
                disabled={!storefrontStore.unsavedChanges}>
                {storefrontStore.unsavedChanges ? "Update" : "Up to date"}
              </Button>
            </form>
            <div className="Storefront_preview">
              <p>Your Store's preview</p>
              <StorefrontPreview />
            </div>
          </div>
        </AppPanel>
      </div>
    )
  }
}

Storefront.displayName = "Storefront"

export default observer(Storefront)



// WEBPACK FOOTER //
// ./src/storefront/Storefront.js